import { useApi } from "@/lib/useApi";
import { VideoRow } from "@/components/VideoRow";

export default function DanceStyles() {
  const { data } = useApi("/dance-styles/rows");
  return (
    <div data-testid="dance-styles-page">
      {data?.rows?.map((row) => (
        <VideoRow key={row.id} title={row.name} videos={row.videos} to={`/styles/${row.slug}`} testId={`style-row-${row.slug}`} />
      ))}
      {data && data.rows.length === 0 && (
        <p className="mt-16 text-[16px] text-[#8A8A8A]" data-testid="styles-empty">
          No dance styles with videos yet.
        </p>
      )}
    </div>
  );
}
